// This partial contains functions and utilities for redirecting
// Users to regional subdomains, e.g www.chupi.com -> uk.chupi.com

function redirectToRegional(url) {
  const redirectURL = () => {
    const redirectParam = 'redirect=true';
    const { origin, pathname, search } = window.location;
    const paramString = search === "" ? `?${redirectParam}` : `${search}&${redirectParam}`
    let newUrl = `${url}${pathname}${paramString}`;
    if (isDev) {
      // Reload (same origin) on dev
      newUrl = `${origin}${pathname}${paramString}`;
    }
    window.location.href = newUrl
  }
  // Function to redirect the user to a regional site and take their cart and wishlist with them
  const cartDetails = {};
  let wkSid = '';
  const isDev = window.location.hostname.indexOf('chupi-dev') > -1;
  // Grab the wishlist id
  const wkLocal = window.localStorage.getItem('appmate-session');
  if (wkLocal) {
    const data = JSON.parse(wkLocal)
    if (data.state.sid) {
      wkSid = data.state.sid;
      const domain = isDev ? 'chupi-dev2.myshopify.com' : '.chupi.com';
      const wishlistCookie = `wishlistSidTransfer=${wkSid}; path=/; domain=${domain};`
      document.cookie = wishlistCookie;
      if (isDev) console.log('Saved wk sid')
    }
  }

  // If there are items in the cart, save them, the note and the attributes
  fetch('/cart.js')
    .then(response => response.json())
    .then(r => {
      if (r.item_count > 0) {
        cartDetails.items = r.items.map(item => {
          return {
            id: item.id,
            variant_id: item.variant_id,
            properties: item.properties,
            quantity: item.quantity
          }
        });
        cartDetails.note = r.note;
        cartDetails.attributes = r.attributes;
        const cartDetailsString = JSON.stringify(cartDetails)
        if (isDev) console.log(cartDetailsString)
        const cartCookie = `cartDetailsTransfer=${cartDetailsString}; path=/; domain=chupi-dev2.myshopify.com;`
        if (isDev) console.log()
        document.cookie = cartCookie;
        if (isDev) console.log('Saved cart cookie');
        redirectURL();
      } else {
        // Redirect
        redirectURL();
      }
    })
    .catch(err => console.error(err))
}

function updateAllWishlistButtons() {
  const allButtons = Array.from(document.querySelectorAll('.wishlist-add'));
  const idsInWishlist = Appmate.wk.collection.items[0].products.map(p => p.id);
  allButtons.forEach(b => {
    if (idsInWishlist.indexOf(b.getAttribute('data-product-id')) > -1) {
      b.classList.add('active');
    } else {
      b.classList.remove('active');
    }
  })
}

function addItemsToCart(items) {
  return new Promise((resolve, reject) => {
    const payload = {
      items: items
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(r => {
      resolve();
    })
    .catch(err => reject(err))
  })
}

function deleteCookie(cookieName) {
  const domain = window.location.hostname.indexOf('chupi-dev') > -1 ? '.chupi-dev2.myshopify.com' : '.chupi.com';
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00; path=/; domain=${domain};`
}

async function catchRegionalRedirect() {
  const wkTransferCookie = getCookie('wishlistSidTransfer');
  const cartTransferCookie = getCookie('cartDetailsTransfer');
  const isDev = window.location.hostname.indexOf('chupi-dev') > -1;
  // Set the wishlist SID here if there isn't one already
  if (wkTransferCookie !== '') {
    console.log('Found WK cookie')
    if (Appmate.wk.collection.items[0].products.length == 0) {
      if (isDev) console.log('No wk products')
      const wkLocal = window.localStorage.getItem('appmate-session');
      if (wkLocal) {
        if (isDev) console.log('Got wkLocal')
        const data = JSON.parse(wkLocal);
        data.state.sid = wkTransferCookie;
        window.localStorage.setItem('appmate-session', JSON.stringify(data));
        if (isDev) console.log('Updated WK SID');
        // Delete the cookie
        deleteCookie('wishlistSidTransfer')
        // Restart WK
        try {
          window.setTimeout(() => {
            Appmate.init(Appmate.config);
            updateAllWishlistButtons()
          }, 500)
          if (isDev) console.log('Reinitialised wk');
        } catch (err) {
          console.error(err)
        }
      }
    }
  }
  // Bring the cart details in if there isn't a cart
  if (cartTransferCookie !== '') {
    if (isDev) console.log('Found cart cookie');
    const cartData = await fetch('/cart.json').then(response => response.json())
    const { attributes, items, note } = cartData;
    // Check there are no attributes, line items or notes already
    if (Object.entries(attributes).length === 0 && items.length === 0 && (note === null || note === '')) {
      const savedData = JSON.parse(cartTransferCookie);
      const updates = {
        "attributes": savedData.attributes,
        "note": savedData.note,
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => response.json())
      .then(() => {
        const items = savedData.items.map(item => {
          return {
            id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties
          }
        })
        addItemsToCart(items)
        .then(() => deleteCookie('cartDetailsTransfer'))
        .then(() => window.cart.reload())
      })
      .catch(error => {
        console.error('Error:', error);
      });
    } else {
      deleteCookie('cartDetailsTransfer');
    }
  }
}

function ukRedirectOverlay() {
  // Function to show UK redirect overlay if not closed already
  const overlay = document.querySelector('#uk-redirect-overlay');
  const isUkSite = window.location.href.indexOf('uk.chupi.com') !== -1;
  if (overlay && !isUkSite) {
    // Event Listeners
    const redirectButton = overlay.querySelector('.redirect');
    redirectButton.onclick = () => redirectToRegional('https://uk.chupi.com');
    const closeButtons =  Array.from(overlay.querySelectorAll('.close-btn'));
    closeButtons.forEach(b => b.addEventListener('click', () => {
      console.log('Setting cookie for hiding prompt')
      // Set a cookie to hide the overlay for the session
      setCookie('uk-redirect-hidden', 'true', 1);
    }))
    // Show Overlay
    if (getCookie('uk-redirect-hidden') === "") {
      window.setTimeout(() => {
        overlay.classList.add('active');
        handleFixedElements('hide');
      }, 100)
    }
  }
}
window.addEventListener('load', () => {
  const isDev = window.location.hostname.indexOf('chupi-dev') > -1;

  ukRedirectOverlay();

  if (window.location.search.indexOf('redirect=true') !== -1) {
    if (isDev) console.log('Redirect param found');
    catchRegionalRedirect();
  }

})
